<template><render /></template>

<script setup lang="ts">
import escapeHtml from 'escape-html';
import { type Component, h } from 'vue';

import { useFischer } from '@/composables/fischerPlugin';
import type { Placeholder } from '@/sitecoreState';

import FieldInjectorFi from './FieldInjectorFi.vue';

const props = withDefaults(
  defineProps<{
    placeholder?: Placeholder[];
    placeholderProps?: object;
    wrapperComponent?: Component;
  }>(),
  {
    placeholder: () => [],
    placeholderProps: () => ({}),
    wrapperComponent: undefined,
  },
);

const fischer = useFischer();

const render = () => {
  let nonCodeIdx = 0;
  try {
    return props.placeholder.map((item: Placeholder) => {
      try {
        if (item.name === 'code' && item.type === 'text/sitecore') {
          const content = item.contents as unknown as string; // this should always be a string for text/sitecore
          return h('code', {
            ...item.attributes,
            key: undefined,
            '^key': item.attributes.key,
            innerHTML: escapeHtml(content),
          });
        }
        const placeholderIdx = nonCodeIdx;
        nonCodeIdx += 1;
        return h(FieldInjectorFi, {
          componentName: item.componentName || item.renderingName,
          wrapperComponent: props.wrapperComponent,
          fields: item.fields || item.contents,
          placeholders: item.placeholders,
          placeholderIdx,
          placeholderProps: props.placeholderProps,
          placeholder: item,
        });
      } catch (error) {
        console.error('failed rendering for placeholder', item, error);
        fischer.markSsrError(
          `failed rendering for placeholder ${item.componentName || item.renderingName}`,
        );
        return h('div', 'failed to render placeholder');
      }
    });
  } catch (error) {
    console.error(error);
    fischer.markSsrError('failed to render placeholders');
    return h('div', 'failed to render placeholders');
  }
};
</script>

<style scoped src="./placeholder-fi" />
